module.exports = __webpack_public_path__ + "static/img/p8-1.ca7f000.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/p8-1.jpg
// module id = aH5q
// module chunks = 1